import { createQueryKeys } from '@lukemorales/query-key-factory';
import { axios } from '@repo/http';
import { useQuery } from '@tanstack/react-query';
import { get_org_project_list_path, GET_ORG_PROJECT_LIST_PATH } from 'ze-api-contract/organization-v2/get-project-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export const orgProjectList = createQueryKeys('organization', {
    projectList: (param)=>{
        let { organization, queryParams } = param;
        return {
            queryKey: [
                GET_ORG_PROJECT_LIST_PATH,
                organization,
                queryParams
            ],
            queryFn: async ()=>{
                if (!organization) {
                    return [];
                }
                const params = queryParams;
                return axios.get(get_org_project_list_path({
                    organization
                }), {
                    params
                }).then((res)=>res.data.entities);
            }
        };
    }
});
/**
 * Get specific organization project list.
 *
 * @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md
 */ export function useProjectList(param) {
    let { organization, queryParams } = param;
    const { isLoading, data: projectList, error } = useQuery(orgProjectList.projectList({
        organization,
        queryParams
    }));
    return {
        projectList,
        isLoading,
        error
    };
}
